exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n#yacurier-form .small-form{background:#FFF;border:1px solid #f2f6fc;box-shadow:0 14px 20px 0 rgba(164,182,206,0.5);min-width:400px;padding:30px 25px 25px\n}\n#yacurier-form .small-form .search-input-field{margin-top:20px\n}\n#yacurier-form .small-form .search-input-field:first-child{margin-top:0\n}\n", ""]);



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader/dist/cjs.js!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-039c8484","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/blocks/SmallForm/Index.vue
// module id = 42
// module chunks = 0